import styled, { css } from "styled-components";

export const Container = styled.div`
    flex: auto;
    position: relative;
    opacity: 0.6;
    pointer-events: none;

    div{
        position: absolute;
        top: -2.5rem;

        p{
            margin-top: 0.2rem;
            font-size: 0.85rem;
        }

        @media (max-width: 400px){
            strong{
                font-size: 0.9rem;
            }

            p{
                font-size: 0.7rem;
            }
        }
    }

    input{
        width: 100%;
        padding: 0.7rem;
        border: 1.5px solid #dadada;
        border-radius: 5px;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &[type=number] {
            -moz-appearance: textfield;
        }
    }

    ${props => props.inputActive && css`
        opacity: 1;
        pointer-events: all;
        input{
            border: 1.5px solid #7A05A7;
        }
    `}
`